<script lang="ts">

  import httpClient from "$lib/axios-client"
  import { Button } from "$lib/components/ui/button"
  import { ImageWithFallback } from "$lib/components/ui/image-with-fallback"
  import type { _response } from "$lib/data/type/_response"
  import { createQuery } from "@tanstack/svelte-query"
  import ChevronRightIcon from "@lucide/svelte/icons/chevron-right"

  type News = {
    id: number | string
    name: string
    image_url: string
    datetime: string
  }

  let { prefix }: { prefix: string } = $props()

  const query = createQuery(() => ({
    queryKey: ["info"],
    queryFn: async () => {
      return (await httpClient.get<_response<News[]>>(`/api/${prefix}/info/newss`)).data.result ?? []
    },
  }))

</script>

<div>
  <div class="mx-3 mb-2 flex items-center justify-between">
    <h3 class="mb-0 text-sm font-semibold">Berita</h3>
    <Button
      href={`/${prefix}/news`}
      variant="ghost"
      class="h-6 gap-0 pe-0">
      semua
      <ChevronRightIcon/>
    </Button>
  </div>
  <div class="flex snap-x gap-3 overflow-x-auto px-3 pb-2">
    {#if query.isFetching || query.isError}
      <div class="w-full shrink-0 rounded-md border">
        <div class="h-40 rounded-t-md bg-muted"></div>
        <div class="h-12 bg-muted p-2"></div>
      </div>
    {/if}
    {#if !query.isFetching && !query.isError && (query.data ?? []).isEmpty()}
      <div class="flex h-52 w-full shrink-0 items-center justify-center rounded-md border text-xs text-muted-foreground">
        Tidak ada berita
      </div>
    {/if}
    {#each query.data ?? [] as news (news.id)}
      <a
        href={`/${prefix}/news`}
        class="w-full shrink-0 snap-start overflow-hidden rounded-md border">
        <ImageWithFallback
          src={news.image_url}
          alt={news.name}
          class="h-40 w-full rounded-b-none"/>
        <div class="p-2 text-xs">
          <div class="line-clamp-1 font-semibold">{news.name}</div>
          <div class="font-light">{news.datetime.toDateFormat("EEEE, dd MMMM yyyy")}</div>
        </div>
      </a>
    {/each}
  </div>
</div>
